import { useNavigate, useRouter } from '@tanstack/react-router'
import { authClient } from '@/lib/auth-client'

export const useSignOut = () => {
  const router = useRouter()
  const navigate = useNavigate()

  return async (): Promise<void> => {
    await authClient.signOut()
    router.invalidate()
    navigate({ to: '/login' })
  }
}
